const LightBulbIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5081 4.87842C11.5518 4.87839 7.54105 8.83595 7.47828 13.7919C7.44031 16.7897 8.86327 19.457 11.0801 21.1267C11.7539 21.6342 12.1585 22.4217 12.1585 23.2653V24.1578C12.1585 24.9034 12.7629 25.5078 13.5085 25.5078H19.5076C20.2532 25.5078 20.8577 24.9034 20.8577 24.1578V23.2844C20.8577 22.4348 21.2592 21.6367 21.9378 21.1254C24.1247 19.4774 25.5386 16.8583 25.5386 13.909C25.5386 8.92146 21.4956 4.87845 16.5081 4.87842Z"
        stroke="url(#paint0_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8421 26.792H13.1728C12.7953 26.792 12.4893 27.098 12.4893 27.4755C12.4893 27.853 12.7953 28.159 13.1728 28.159H19.8421C20.2196 28.159 20.5256 27.853 20.5256 27.4755C20.5256 27.098 20.2196 26.792 19.8421 26.792Z"
        stroke="url(#paint1_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1867 29.3604H13.831C13.4535 29.3604 13.1475 29.6664 13.1475 30.0439C13.1475 30.4213 13.4535 30.7274 13.831 30.7274H19.1867C19.5642 30.7274 19.8702 30.4213 19.8702 30.0439C19.8702 29.6664 19.5642 29.3604 19.1867 29.3604Z"
        stroke="url(#paint2_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5078 6.51514C20.6006 6.51514 23.9187 9.83075 23.9228 13.9227"
        stroke="url(#paint3_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.65163 21.6357L7.5166 22.7708"
        stroke="url(#paint4_linear_7122_9196)"
        strokeWidth="0.771084"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.48995 13.8174H3.88477"
        stroke="url(#paint5_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.78054 6.05251L7.64551 4.91748"
        stroke="url(#paint6_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5996 2.88985V1.28467"
        stroke="url(#paint7_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.3652 6.18289L25.5003 5.04785"
        stroke="url(#paint8_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.5254 14.001H29.1306"
        stroke="url(#paint9_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.2354 21.7651L25.3704 22.9002"
        stroke="url(#paint10_linear_7122_9196)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7122_9196"
          x1="7.092"
          y1="15.1931"
          x2="25.9242"
          y2="15.1931"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7122_9196"
          x1="12.1037"
          y1="27.4755"
          x2="20.9112"
          y2="27.4755"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_7122_9196"
          x1="12.7619"
          y1="30.0439"
          x2="20.2557"
          y2="30.0439"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_7122_9196"
          x1="16.1223"
          y1="10.2189"
          x2="24.3083"
          y2="10.2189"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_7122_9196"
          x1="8.35674"
          y1="22.4759"
          x2="7.8115"
          y2="21.9306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7122_9196"
          x1="nan"
          y1="nan"
          x2="nan"
          y2="nan"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_7122_9196"
          x1="7.94041"
          y1="5.75762"
          x2="8.48564"
          y2="5.21238"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_7122_9196"
          x1="nan"
          y1="nan"
          x2="nan"
          y2="nan"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint8_linear_7122_9196"
          x1="24.6601"
          y1="5.34275"
          x2="25.2054"
          y2="5.88799"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint9_linear_7122_9196"
          x1="nan"
          y1="nan"
          x2="nan"
          y2="nan"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
        <linearGradient
          id="paint10_linear_7122_9196"
          x1="25.0755"
          y1="22.06"
          x2="24.5303"
          y2="22.6053"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#027C80" />
          <stop
            offset="1"
            stopColor="#02E5EB"
          />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LightBulbIcon;
